module.exports = __webpack_public_path__ + "media/images/fill-11@2x-603ec98b0c326f3c5b04621f5986409e.png";